import { render, staticRenderFns } from "./ProdApp.vue?vue&type=template&id=4ea08217&scoped=true&"
import script from "./ProdApp.vue?vue&type=script&lang=js&"
export * from "./ProdApp.vue?vue&type=script&lang=js&"
import style0 from "./ProdApp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProdApp.vue?vue&type=style&index=1&id=4ea08217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../gotti-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea08217",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\joevi\\source\\repos\\gotti-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea08217')) {
      api.createRecord('4ea08217', component.options)
    } else {
      api.reload('4ea08217', component.options)
    }
    module.hot.accept("./ProdApp.vue?vue&type=template&id=4ea08217&scoped=true&", function () {
      api.rerender('4ea08217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "builds/_prebuild/Client/ProdApp.vue"
export default component.exports